import { PageContent } from "../../pages/templates/PageLayout";

const content: PageContent = {
  style: "darkGradient",
  sections: [
    {
      type: "FormSection",
      title: "Let’s get your assets organized!",
      subtitle:
        "Equip your team with the one platform needed to execute elite digital asset management and brand guideline requirements, from creation to distribution.",
      badge: "Contact sales",
      form: "sales",
      position: { mb: "none", pb: "xxxl" },
    },
    { type: "CustomerLogosSection", position: { mt: "-xl" } },
    { type: "TestimonialSection" },
    {
      type: "CtaSection",
      title: "Build your first kit in 5 minutes or less",
      body: "Organize, store, find, and share your brand assets in one library, from anywhere.",
    },
  ],
};

export default content;
